<p-button
    [id]="id() + '-btn'"
    [type]="'button'"
    [severity]="severity()"
    [icon]="icon()"
    [disabled]="disabled()"
    [loading]="loading()"
    [rounded]="rounded()"
    [text]="text()"
    [outlined]="outlined()"
    [size]="size()"
    [styleClass]="class()"
    [severity]="severity()"
    [pTooltip]="tooltip() | translate"
    [tooltipPosition]="tooltipPosition()"
    [tooltipDisabled]="tooltipDisabled()"
    [ariaLabel]="ariaLabel()"
    [attr.aria-disabled]="disabled()"
    (onClick)="onClick.emit($event)">
    <ng-content></ng-content>
</p-button>
